module.exports = __webpack_public_path__ + "media/images/cardboard_pack-14b6c34974860423b46be15a54bd2ba7.webp";